module.exports = __webpack_public_path__ + "static/media/detail.5f1fbc14.svg";